import { render, staticRenderFns } from "./StatisticsModal.vue?vue&type=template&id=1dd6bf16"
import script from "./StatisticsModal.vue?vue&type=script&lang=js"
export * from "./StatisticsModal.vue?vue&type=script&lang=js"
import style0 from "./StatisticsModal.vue?vue&type=style&index=0&id=1dd6bf16&prod&lang=scss"
import style1 from "./StatisticsModal.vue?vue&type=style&index=1&id=1dd6bf16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
